import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../../environments/environment';
import { MongoResource } from '../../shared/mongo.resource';
import { Configurations } from '../shared/configurations.model';

@Injectable()
export class ConfigurationsService extends MongoResource<any, any, any> {
  baseUrl = environment.api + 'configurations';

  getAllTypes(): Observable<any[]> {
    return this.$get('types');
  }

  updateConfigById(id: any, body: Configurations): Observable<Configurations> {
    return this.$post<Configurations, Configurations>(id, body);
  }

  constructor(public http: HttpClient) {
    super(http);
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/configurations/shared/configurations.service.ts